import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actionCreators from 'actions/creators';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import classNames from "classnames";
import CupoyRouter from "components/commons/router/CupoyRouter";
import GLOBAL from 'jcolorglobal';

class CreateManualAllowanceView extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this
            .handleSubmit
            .bind(this);

        this.addProduct = this
            .addProduct
            .bind(this);

        this.state = {
            allowanceNumber: '',
            yearmonth: '',
            invoicenumber: '',
            istarttag: '',
            allowanceAmount: 0,
            buyerName: '',
            buyerCrn: GLOBAL.DEFAULT_BUYERCRN,
            allowanceDay: new Date(),
            invoiceDay: new Date(),
            pdtlist: [
                { pdtcount: 1, pdtprice: 0}
            ],
            invoicePdtlist: [],
            isLoading: false,
            isError: false,
            errorMsg: '',
            isParamsError: false,
            isParamsErrorMap: {},
            fromState: undefined,
            isLoadingInfo: false,
            isInfoError: false
        }
    }

    componentDidMount() {

        var stateHistory = CupoyRouter.getHistory();
        var fromState;

        if (stateHistory.length > 1) {

            for (var i = 0; i < stateHistory.length; i++) {
                var prev = stateHistory[stateHistory.length - i],
                    statename;

                if (prev) {
                    statename = prev.state.name;

                    if (statename === CupoyRouter.STATES.INVOICE_LIST) {
                        fromState = prev;
                        break;
                    }
                }
            }
        }

        this.setState({fromState: fromState});

    }

    onInputChange(fieldname, event) {

        this.setState({[fieldname]: event.target.value});
        if(fieldname === 'invoicenumber'){
            this.setState({allowanceNumber: event.target.value});
        }
    }

    onPdtCountInputChange(index, event) {

        var value = event.target.value;

        const pdt = this.state.pdtlist[index];

        const newpdt = Object.assign({}, pdt, {pdtcount: value})
        const newpdtlist = this.state.pdtlist;

        newpdtlist[index] = newpdt;

        this.setState({
            pdtlist: newpdtlist
        }, () => {
            this.updateNewSalesamount()
        });
    }

    onPdtPriceInputChange(index, event) {

        var value = event.target.value;

        const pdt = this.state.pdtlist[index];

        const newpdt = Object.assign({}, pdt, {pdtprice: value})
        const newpdtlist = this.state.pdtlist;

        newpdtlist[index] = newpdt;

        this.setState({
            pdtlist: newpdtlist
        }, () => {
            this.updateNewSalesamount()
        });
    }

    onPdtInputChange(fieldname, index, event) {

        var value = event.target.value;

        const pdt = this.state.pdtlist[index];

        const newpdt = Object.assign({}, pdt, {[fieldname]: value})
        const newpdtlist = this.state.pdtlist;

        newpdtlist[index] = newpdt;

        this.setState({pdtlist: newpdtlist});
    }

    updateNewSalesamount() {

        this.setState({
            allowanceAmount: this
                .state
                .pdtlist
                .reduce((total, product) => {
                    return total + Math.round(product.pdtcount * product.pdtprice * 1.05);
                }, 0)
        });
    }

    handleSubmit(event) {

        event.preventDefault();

        if (this.state.isLoading) {
            return;
        }

        const {
            allowanceNumber,
            yearmonth,
            invoicenumber,
            allowanceAmount,
            buyerName,
            buyerCrn,
            allowanceDay,
            invoiceDay,
            pdtlist
        } = this.state;

        

        if (allowanceAmount <= 0) {
            return;
        }

        var isParamsError = false;
        var isParamsErrorMap = {};

        const allowancedate = allowanceDay.getTime();
        const invoicedate = invoiceDay.getTime();

        if (!allowanceNumber) {
            isParamsErrorMap['allowanceNumber'] = true;
            isParamsError = true;
        }

        var pdtlistResult = [];

        for (var i = 0; i < pdtlist.length; i++) {
            var product = pdtlist[i];

                product.isParamsErrorMap['pdtprice'] = false;

                if (product.pdtprice <= 0) {
                    product.isParamsErrorMap['pdtprice'] = true;
                    isParamsError = true;
                }
                pdtlistResult.push({pdtcount: product.pdtcount, pdtid: product.pdtid, pdtname: product.pdtname, pdtprice: product.pdtprice});
        }

        if (pdtlistResult.length === 0) {
            isParamsError = true;
        }

        if (isParamsError) {

            this.setState({pdtlist: pdtlist, isParamsError: isParamsError, isParamsErrorMap: isParamsErrorMap})

            return;
        }
        const istarttag = invoicenumber.substring(0,2);
        const invoiceNumber = invoicenumber.substring(2);
        const payload = {
            buyername: buyerName,
            buyercrn: buyerCrn,
            yearmonth: yearmonth,
            istarttag,
            invoiceNumber,
            allowanceNumber: allowanceNumber,
            allowancedate: allowancedate,
            invoicedate,
            pdtlist: pdtlistResult
        };

        this.setState({
            isLoading: true,
            errorMsg: '',
            pdtlist: pdtlist,
            isParamsError: isParamsError,
            isParamsErrorMap: isParamsErrorMap
        }, () => {
            this
                .props
                .allowanceActions
                .createAllowance(payload)
                .then((result) => {

                    if (result) {
                        // 重拉資料更新store
                        this
                        .props
                        .webActions
                        .cupoyStateGo(CupoyRouter.STATES.ALLOWANCE_LIST, {page: 1});

                    } else {
                        this.setState({isLoading: false, errorMsg: '發生無法處理的錯誤，請聯絡工程師'});
                    }
                }, (error) => {
                    if (error && error.message) {
                        this.setState({isLoading: false, errorMsg: error.message});
                    } else {
                        this.setState({isLoading: false, errorMsg: '發生無法處理的錯誤，請聯絡工程師'});
                    }
                });
        })
    }

    // ------------------------------ 時間變動 ------------------------------
    onDaySelectChange(selectedDay, modifiers) {

        this.setState({allowanceDay: selectedDay});
    }

    onInvoiceDaySelectChange(selectedDay, modifiers) {

        this.setState({invoiceDay: selectedDay});
    }


    // ------------------------------ 將 DatePicker style改為absolute
    // ------------------------------
    renderCustomDayPickerOverlay({classNames, selectedDay, children}) {

        return (
            <div
                className={classNames.overlayWrapper}
                style={{
                position: 'absolute',
                lineHeight: 'normal'
            }}>
                <div className={classNames.overlay}>
                    {children}
                </div>
            </div>
        );
    }

    addProduct() {
        this.setState({
            pdtlist: [
                ...this.state.pdtlist, {pdtcount: 1, pdtprice: 0}
            ]
        })
    }

    removeProductAt(index) {
        this.setState({
            pdtlist: this
                .state
                .pdtlist
                .slice(0, index)
                .concat(this.state.pdtlist.slice(index + 1))
        })

    }

    render() {

        const {
            allowanceNumber,
            allowanceDay,
            allowanceAmount,
            buyerName,
            buyerCrn,
            pdtlist,
            isParamsErrorMap,
            invoicenumber,
            yearmonth,
            invoiceDay,
        } = this.state;

        const allowanceDayValue = allowanceDay
            ? formatDate(allowanceDay, 'YYYY/MM/DD')
            : '';
        const invoiceDayValue = invoiceDay
            ? formatDate(invoiceDay, 'YYYY/MM/DD')
            : '';


        return (

            <div id="create-allowance">
                <div className="header-bar mix">
                    <ul className="bread-crumbs">
                        <li className="crumb-item active">
                            <a>開立折讓單</a>
                        </li>
                    </ul>
                    <div className="button-group">

                        {this.state.isError
                            ? <span className="error">發生無法處理的錯誤，請聯絡工程師</span>
                            : null
}
                        <a className="button blue" onClick={this.handleSubmit}>
                            {this.state.isLoading
                                ? <i className="zmdi zmdi-spinner animate-spinner"></i>
                                : null}
                            開立折讓單
                        </a>
                    </div>
                </div>

                <div className="scroll-content">
                    <div
                        className="form"
                        style={{
                        minHeight: '100%'
                    }}>
                        <div className="block-form">
                            <h3 className="block-title">基本資訊</h3>
                            <div className="block-form-row">
                                <label
                                    className={classNames("block-form-col", {'error': isParamsErrorMap['invoicenumber']})}>
                                    <h5 className="title">
                                        原始發票號碼 {isParamsErrorMap['invoicenumber']
                                            ? <span className="error-tip">請輸入發票號碼</span>
                                            : null}
                                    </h5>
                                    <input
                                        type="text"
                                        value={invoicenumber}
                                        placeholder="點擊輸入原始發票號碼"
                                        onChange={(event) => this.onInputChange('invoicenumber', event)}/>
                                </label>
                            </div>
                            <div className="block-form-row">         
                                <label className="block-form-col">
                                    <h5 className="title">原始發票期別</h5>
                                    <input
                                        type="text"
                                        value={yearmonth}
                                        placeholder="點擊輸入原始發票期別，民國106年一月發票請輸入1060102"
                                        onChange={(event) => this.onInputChange('yearmonth', event)}/>
                                </label>

                                <label className="block-form-col">
                                    <h5 className="title">原始發票開立日期</h5>
                                    <DayPickerInput
                                        overlayComponent={this.renderCustomDayPickerOverlay}
                                        onDayChange={(selectedDay, modifiers) => this.onInvoiceDaySelectChange(selectedDay, modifiers)}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        format="YYYY/MM/DD"
                                        value={invoiceDayValue}
                                        dayPickerProps={{
                                        selectedDays: invoiceDay
                                    }}
                                        placeholder="原始發票開立日期"/>
                                </label>
                            </div>

                            <div className="block-form-row">
                                <label
                                    className={classNames("block-form-col", {'error': isParamsErrorMap['allowanceNumber']})}>
                                    <h5 className="title">
                                        折讓單號碼 {isParamsErrorMap['allowanceNumber']
                                            ? <span className="error-tip">請輸入折讓單號碼</span>
                                            : null}
                                    </h5>
                                    <input
                                        type="text"
                                        value={allowanceNumber}
                                        placeholder="點擊輸入折讓單號碼"
                                        onChange={(event) => this.onInputChange('allowanceNumber', event)}/>
                                </label>
                                <label className="block-form-col">
                                    <h5 className="title">折讓日期</h5>
                                    <DayPickerInput
                                        overlayComponent={this.renderCustomDayPickerOverlay}
                                        onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers)}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        format="YYYY/MM/DD"
                                        value={allowanceDayValue}
                                        dayPickerProps={{
                                        selectedDays: allowanceDay
                                    }}
                                        placeholder="折讓日期"/>
                                </label>
                            </div>
                            <div className="block-form-row">
                                <label
                                    className={classNames("block-form-col", {'error': isParamsErrorMap['buyerName']})}>
                                    <h5 className="title">
                                        買受人抬頭 {isParamsErrorMap['buyerName']
                                            ? <span className="error-tip">請輸入買受人抬頭</span>
                                            : null}
                                    </h5>
                                    <input
                                        type="text"
                                        value={buyerName}
                                        placeholder="點擊輸入買受人抬頭"
                                        onChange={(event) => this.onInputChange('buyerName', event)}/>
                                </label>
                                <label className="block-form-col">
                                    <h5 className="title">買受人統編</h5>
                                    <input
                                        type="text"
                                        value={buyerCrn}
                                        placeholder="點擊輸入買受人統編"
                                        onChange={(event) => this.onInputChange('buyerCrn', event)}/>
                                </label>
                            </div>                            
                        </div>
                        <div className="block-form">
                            <h3 className="block-title">折讓商品資訊</h3>
                            <div className="block-form-wrapper">
                                <div className="block-form-row">
                                    <label className="block-form-col">
                                        <h5 className="title">商品名稱</h5>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">商品編號</h5>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">折讓數量</h5>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">商品單價(未稅)</h5>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">刪除</h5>
                                    </label>

                                </div>

                                {pdtlist.map((product, index) => {

                                    if (!product.isParamsErrorMap) {
                                        product.isParamsErrorMap = {};
                                    }

                                    return (
                                        <div className="block-form-row" key={index}>
                                            <label className="block-form-col">
                                                <input
                                                    type="text"
                                                    value={product.pdtname}
                                                    placeholder="點擊輸入商品名稱"
                                                    onChange={(event) => this.onPdtInputChange('pdtname', index, event)}/>

                                            </label>
                                            <label className="block-form-col">
                                                <input
                                                    type="text"
                                                    value={product.pdtid}
                                                    placeholder="點擊輸入商品編號"
                                                    onChange={(event) => this.onPdtInputChange('pdtid', index, event)}/>

                                            </label>
                                            <label className="block-form-col">
                                                <input
                                                    type="number"
                                                    value={product.pdtcount}
                                                    placeholder="1"
                                                    onChange={(event) => this.onPdtCountInputChange(index, event)}/>
                                            </label>
                                            <label
                                                className={classNames("block-form-col", {'error': product.isParamsErrorMap['pdtprice']})}>
                                                <input
                                                    type="number"
                                                    min={0}
                                                    value={product.pdtprice}
                                                    placeholder="0"
                                                    onChange={(event) => this.onPdtPriceInputChange(index, event)}/>
                                            </label>
                                            <label className="block-form-col">
                                                <a className="button red" onClick={() => this.removeProductAt(index)}>刪除</a>
                                            </label>
                                        </div>
                                    )
                                })}
                                <div className="block-form-row">
                                    <label className="block-form-col">
                                        <h5 className="title">折退金額（含稅）</h5>
                                        <p className="description">
                                            {allowanceAmount}
                                        </p>
                                    </label>
                                </div>
                            </div>

                            <div className="button-group">
                                <a className="button blue" onClick={this.addProduct}>
                                    新增折讓商品
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
const mapStateToProps = function (state) {
    return {invoices: state.invoice.invoices};
};

const mapActionToProps = function (dispatch) {
    return {
        invoiceActions: bindActionCreators(actionCreators.invoiceActionCreators, dispatch),
        allowanceActions: bindActionCreators(actionCreators.allowanceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {withRef: true})(CreateManualAllowanceView);


// WEBPACK FOOTER //
// ./src/components/allowance/CreateManualAllowanceView.js